export const emptyValue = "Não informado";

export function normalizeText(value: string) {
  return value.trim().toLowerCase();
}

export function onlyDigits(value?: string | null) {
  return value?.replace(/\D/g, "") ?? "";
}

export function normalizeCnpj(value?: string | null) {
  return value?.toUpperCase().replace(/[^A-Z0-9]/g, "") ?? "";
}

export function formatOptional(value?: string | null) {
  return value?.trim() || emptyValue;
}

export function formatBoolean(value: boolean) {
  return value ? "Sim" : "Não";
}

export function formatCpf(value: string) {
  const digits = onlyDigits(value);
  if (digits.length !== 11) return formatOptional(value);
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export function formatPhone(value: string) {
  const digits = onlyDigits(value);
  if (digits.length === 11) {
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
  if (digits.length === 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }
  return formatOptional(value);
}

export function formatCnpj(value: string) {
  const cnpj = normalizeCnpj(value);
  if (!cnpj) return emptyValue;
  if (cnpj.length !== 14) return value;
  return cnpj.replace(
    /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/,
    "$1.$2.$3/$4-$5",
  );
}

export function formatCep(value: string) {
  const digits = onlyDigits(value);
  if (digits.length !== 8) return formatOptional(value);
  return digits.replace(/(\d{5})(\d{3})/, "$1-$2");
}
